<script setup lang="ts">
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'

import BaseLayerVector from '@/components/map/base-layers/BaseLayerVector.vue'
import { useMapStore } from '~/stores/map'

const mapStore = useMapStore()
const activeCountyId = computed(() => mapStore.activeCountyId)

const { features } = useGeojsonDataFetch('counties', {
  generalStyle: undefined,
})

// vi skjuter in stylen för aktiv rakt in
watch(features, () => {
  setFeatures()
})
if (features.value.length) {
  setFeatures()
}

function setFeatures() {
  if (!features.value.length) return
  features.value.forEach((feature) => {
    // sätt en allmän label prop - den här följer med till featuren
    feature.set('label', feature.get('county_name'))
    feature.set('link', '/utforska-en-plats/region/' + feature.get('slug'))
    feature.set('type', 'region')

    if (feature.get('county_code') === activeCountyId.value) {
      const strokeWidth = 2
      const color = 'black'
      const vectorStyle = new Style({
        stroke: new Stroke({
          width: strokeWidth,
          color,
        }),
        zIndex: 90,
      })
      feature.setStyle(vectorStyle)
    }
  })
}
</script>

<template>
  <BaseLayerVector v-if="features.length" :features="features" />
</template>
